import { faFileExport, faSync } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, notification } from 'antd'
import { TimesheetsSelection } from './TimesheetsGrid'
import { formatHours } from './timesheetsModel'
import { useExportTimesheetsToQuickBooksMutation } from './timesheetsQueries'

type Props = {
  selection: TimesheetsSelection
  deletedView: boolean
}

const TimesheetsExportBar = ({ selection, deletedView }: Props) => {
  const exportMutation = useExportTimesheetsToQuickBooksMutation(errors => {
    if (errors.length > 0) {
      notification.error({
        message: 'Some timesheets could not be exported to QuickBooks',
        description: errors.join('\n'),
        duration: 0,
      })
    }
  })

  return <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
    <Button
      type="primary"
      icon={<FontAwesomeIcon icon={faFileExport} />}
      onClick={() => exportMutation.mutate(selection.ids)}
      disabled={deletedView || selection.ids.length === 0 || exportMutation.isLoading}
    >
      Export {formatHours(selection.hours)} selected hours to QuickBooks
    </Button>
    {exportMutation.isLoading && <span>
      <FontAwesomeIcon icon={faSync} spin /> Exporting selected timesheets to QuickBooks Online
    </span>}
  </div>
}

export default TimesheetsExportBar
